/* eslint-disable global-require */
import { getEnvParam } from 'env'
import { SERVICE_MY_RECORD_NAME, SERVICE_NAME } from 'service.js'
import { SERVER_NAME } from 'conf.js'
import { featureFlags } from 'config/feature-flags'
import { isTotpViewAllowed } from 'utils/plan'
import AllIcon from '@/assets/images/menu/icon-all-menu.svg'
import MyIcon from '@/assets/images/menu/icon-my-menu.svg'
import FavoriteIcon from '@/assets/images/menu/icon-favorite-menu.svg'
import GroupIcon from '@/assets/images/menu/icon-group-menu.svg'
import CategoryIcon from '@/assets/images/icon-tag-24.svg'
import ExportIcon from '@/assets/images/menu/icon-expired-menu.svg'
// 메모 탭 아이콘 — 메모 리스트/그리드 카드의 노란색 file 아이콘과 같은 문서 모양(feather 'file')으로 통일.
// 사이드바 색은 RecordMenu 의 `svg * { stroke: currentcolor !important }` 가 메뉴 톤(선택 시 primary)으로 강제하므로 모양만 맞춘다.
import MemoIcon from '@/assets/images/icon-file-24.svg'
// 방패+체크(기존 icon-setings-security-24 형태를 메뉴 톤 #111827 로 파생 — #1499)
import AuthenticatorIcon from '@/assets/images/menu/icon-authenticator-menu.svg'

const configMap = {}

export const isDevelopJapan =
  process.env.REACT_APP_TARGET === SERVER_NAME.JAPAN_DEV ||
  process.env.REACT_APP_TARGET === SERVER_NAME.JAPAN_STAGING

export const commonMenuList = (i18n, adminConsoleMenuList = null) => {
  return [
    {
      divider: true,
    },
    {
      title: i18n.t('menu.record.all'),
      key: 'allRecords',
      url: '/records/all',
      icon: AllIcon,
    },
    {
      divider: true,
    },
    // 탭 순서: 즐겨찾기 → 패스워드 → 메모 → 인증 코드 → 만료 (2026-08-07 사용자 결정)
    {
      title: i18n.t('menu.record.favorites'),
      key: 'favorites',
      url: '/records/favorites',
      icon: FavoriteIcon,
    },

    // sharedRecordTabs ON: 목록 내 탭(내/공유받은)을 담는 "패스워드" 통합 탭으로 개명.
    // key/url 유지 — RecordMenu 배지 매핑(menuInfoMap.myRecords)·라우팅에 영향 없음.
    {
      title: featureFlags.sharedRecordTabs
        ? i18n.t('menu.record.passwords')
        : i18n.t(SERVICE_MY_RECORD_NAME, { service: i18n.t(SERVICE_NAME) }),
      key: 'myRecords',
      url: '/records/mine',
      icon: MyIcon,
    },

    // 메모 탭 — featureFlags.memoTemplate 게이트 (2026-07-23 ab28309d0 전 환경 ON — 킬스위치로 유지)
    ...(featureFlags.memoTemplate
      ? [
          {
            title: i18n.t('menu.record.memo'),
            key: 'memoRecords',
            url: '/records/memo',
            icon: MemoIcon,
          },
        ]
      : []),

    // 인증 코드 탭(#1495) — isTotpViewAllowed 게이트(totpAuthenticator 킬스위치, 2026-08-06 205efd847 전 환경 ON).
    // Basic(JP·PAID)도 탭은 활성 유지(정책 변경 2026-08-24) — 기존 TOTP 조회를 위해 접근을 막지
    // 않고, 생성 불가 안내는 인증 코드 리스트 상단 배너(pages/records/authenticator)가 담당한다.
    ...(isTotpViewAllowed()
      ? [
          {
            title: i18n.t('menu.authenticator'),
            key: 'authenticator',
            url: '/records/authenticator',
            icon: AuthenticatorIcon,
            // 제목 옆 정보 아이콘 툴팁 — 목록에서 OTP 코드를 바로 확인할 수 있음을 안내
            infoTooltip: i18n.t('menu.authenticatorInfo'),
          },
        ]
      : []),

    {
      title: i18n.t('menu.record.expired'),
      key: 'expiredRecords',
      url: '/records/expired',
      icon: ExportIcon,
    },

    {
      title: i18n.t('menu.groups'),
      key: 'groups',
      icon: GroupIcon,

      children: [
        {
          title: 'group1',
          key: 'group1',
          url: '/records/groups',
        },
      ],
    },

    {
      title: i18n.t('menu.labels'),
      key: 'categories',
      icon: CategoryIcon,

      children: [
        {
          title: 'category1',
          key: 'category1',
          url: '/records/categories',
        },
      ],
    },

    ...(adminConsoleMenuList != null && Array.isArray(adminConsoleMenuList)
      ? adminConsoleMenuList
      : []),
  ]
}

export default function appTypeConfigFunc() {
  let appTypeInfo = {}
  try {
    appTypeInfo = JSON.parse(getEnvParam('appType') || '{}')
  } catch {
    appTypeInfo = {}
  }

  const appType = appTypeInfo.role

  if (configMap[appType] == null) {
    const config = {}

    // console에서는 workspace.role을 기준으로 구분.
    switch (appType) {
      case 'owner':
      case 'admin':
        config.menu = require('./admin/menu.ts').default
        config.router = require('./admin/router.ts').default
        config.config = require('./admin/config.ts').default
        break
      case 'user':
      default:
        config.menu = require('./user/menu.ts').default
        config.router = require('./user/router.ts').default
        config.config = require('./user/config.ts').default
    }

    configMap[appType] = config
  }

  return configMap[appType]
}
